
const unifiedLink = '/buy?product={plan}&period={cycle}&reference=opc&usageType=business'

function getLink(params) {
  return unifiedLink.replace(/\{(\w+)}/g, (match, key) => params[key] || '');
}

const AIC_LINK = {
  plan: 'AICSTD',
  cycle: 'annual'
}

export const AIC_UNIFIED_LINK = getLink(AIC_LINK)
